import { updateCell } from "./update-cell";

export function clearSingleHover(scenegraph, col, row, selectRanges, selectMode) {
    return updateCell(scenegraph, col, row), !0;
}

export function updateSingleHover(scenegraph, col, row, selectRanges, selectMode) {
    return updateCell(scenegraph, col, row), !0;
}
//# sourceMappingURL=single.js.map
